"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var markdown_it_1 = __importDefault(require("markdown-it"));

var mark_1 = __importDefault(require("./mark"));

var checkboxes_1 = __importDefault(require("./checkboxes"));

var embeds_1 = __importDefault(require("./embeds"));

var breaks_1 = __importDefault(require("./breaks"));

var tables_1 = __importDefault(require("./tables"));

var notices_1 = __importDefault(require("./notices"));

var underlines_1 = __importDefault(require("./underlines"));

function rules(_ref) {
  var embeds = _ref.embeds;
  return markdown_it_1.default("default", {
    breaks: false,
    html: false
  }).use(embeds_1.default(embeds)).use(breaks_1.default).use(checkboxes_1.default).use(mark_1.default({
    delim: "==",
    mark: "mark"
  })).use(mark_1.default({
    delim: "!!",
    mark: "placeholder"
  })).use(underlines_1.default).use(tables_1.default).use(notices_1.default);
}

exports.default = rules;